import React from "react";
import { useClient } from "../../../../hooks/useClient";
import ClientExerciseHistoryPage from "../../../../components/client-exercise-history/ClientExerciseHistoryPage";

export const CoachClientExerciseHistoryRoute = () => {
  const { id, username } = useClient();

  return <ClientExerciseHistoryPage clientId={id} clientUsername={username} />;
};
